import React from 'react'
import { element } from 'prop-types'
import { Navbar, Brand, Image } from '@cobalt/cobalt-react-components'
import { LOGO_ALTERNATE_TEXT } from '../../constants/ui.labels'
import { ROOT } from '../../constants/links'
import { TALKDESK_LOGO } from '../../constants/images'

const TalkdeskNavbar = ({ actionElement }) => {
  return (
    <Navbar shadow>
      <Navbar.Primary>
        <Navbar.Container>
          <Brand href={ROOT}>
            <Image
              src={TALKDESK_LOGO}
              alt={LOGO_ALTERNATE_TEXT}
              width={100}
              height={20}
            />
          </Brand>
        </Navbar.Container>
        {actionElement && (
          <Navbar.Container minimal>
            <Navbar.Actions>{actionElement}</Navbar.Actions>
          </Navbar.Container>
        )}
      </Navbar.Primary>
    </Navbar>
  )
}

TalkdeskNavbar.propTypes = {
  actionElement: element
}

export default TalkdeskNavbar
